// Assets from src/assets are copied below /dist/images by the existing webpack
// setup. Using that stable public path also works with the dev server, whereas
// an asset-module import is emitted below `/` and is not served there locally.
export const SQUADY_ICON_SRC = '/dist/images/icons/squady-icon.png';
